import { useEffect, useRef, useState } from "react";
import { useInView, animate } from "framer-motion";

export const Counter = ({ to, suffix = "", duration = 2.2, className = "" }) => {
    const ref = useRef(null);
    const inView = useInView(ref, { once: true, margin: "-60px" });
    const [val, setVal] = useState(0);

    useEffect(() => {
        if (!inView) return;
        const controls = animate(0, to, {
            duration,
            ease: [0.16, 1, 0.3, 1],
            onUpdate: (v) => setVal(Math.round(v)),
        });
        return () => controls.stop();
    }, [inView, to, duration]);

    return (
        <span ref={ref} className={className}>
            {val}
            {suffix}
        </span>
    );
};
